/**
 * A module for functions related to ad targeting
 */

import { readConfigPath } from "../../../utils/js/configMgr.js";
import { getBreakpoint, getSearchParams } from "../../../utils/js/utils.js";
import { logFeature } from "../../../../scriptsCore/js/logging.js";
import {
  getAdCallRatings,
  getIABContext,
  getMantisContext,
} from "../../../../mantis/js/index.js";

const log = (...args) => logFeature("ads", ...args);

/**
 * Calls GPT pubads().setTargeting() with all the relevant args
 */
export function setPageTargeting() {
  log("setPageTargeting");

  const pageData =
    window[readConfigPath("advertisingConfig.pageDataGlobalVar")];
  const searchParams = getSearchParams();

  const pageConfig = {
    breakpoint: getBreakpoint(readConfigPath("breakpoints")),
    gs_cat: window?.gs_channels || "none",
    iab_context: getIABContext() || "unknown",
    iason: true, // this tells GAM to use IAS
    mantis_context: getMantisContext() || "unknown",
    mantis: getAdCallRatings() || "unknown",
    oid: pageData?.oid,
    site: "niche",
    templ: pageData?.pageType,
    token: searchParams.get("token"),
  };

  const pubads = window.googletag.pubads;

  Object.entries(pageConfig).forEach(([key, val]) => {
    if (key && val) {
      pubads().setTargeting(key, val.toString());
    }
  });
}

/**
 * calls GPTSlot.setTargeting() with args from the slot config meta object
 * @param {GPTSlot} slot
 * @param {object} slotMeta
 */
export function setSlotTargeting(slot, slotMeta) {
  // const bp = getBreakpoint(readConfigPath("breakpoints"));
  // const slotsCfg = readConfigPath(
  //   `advertisingConfig.slots.breakpoints.${bp}.gpt`
  // );
  // const slotMeta = slotsCfg.find(
  //   (slotEntry) => slotEntry.slotId === slot.getSlotElementId()
  // );
  Object.entries(slotMeta.targeting).forEach(([key, val]) => {
    slot.setTargeting(key, val);
  });
}
